var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"font-weight-black",class:_vm.status},[_vm._v(" "+_vm._s(_vm._f("code")(_vm.status,'CreditPaysRequest.Status'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }